/*
  Hard Gate for assessments
  - Collect Name/Email/Phone
  - Store in sessionStorage
  - Require selection of which assessment
  - Submit Shopify customer creation form
  - Redirect to chosen assessment after successful capture

  IMPORTANT:
  - On Shopify, posting create_customer may redirect to /account or show errors.
  - We store selection + data before submit.
  - After submit, we use a post-submit redirect mechanism:
      - best: add a hidden return_to input supported by theme
      - fallback: after submit, Shopify redirects; user can revisit /pages/assessments and it will route.
*/

const GATE_KEY = 'fortify_gate_v1';

function saveGateData(data){
  sessionStorage.setItem(GATE_KEY, JSON.stringify(data));
}

function getGateData(){
  try { return JSON.parse(sessionStorage.getItem(GATE_KEY) || 'null'); }
  catch { return null; }
}

function normalizeName(first, last){
  return [first, last].filter(Boolean).join(' ').trim();
}

function targetUrl(target){
  // Static project paths
  if(target === 'coherence') return '../coherence/index.html';
  if(target === 'five-realms') return '../five-realms/index.html';
  if(target === 'clear') return '../clear/index.html';

  // Shopify page paths (if gate is hosted on Shopify)
  if(target === 'shopify-coherence') return '/pages/coherence';
  if(target === 'shopify-five-realms') return '/pages/five-realms';
  if(target === 'shopify-clear') return '/pages/clear';

  return null;
}

document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('gateForm');
  const status = document.getElementById('status');
  const btnSubmit = document.getElementById('btnSubmit');
  const selectedInput = document.getElementById('selected');

  let selectedTarget = null;

  function validate(){
    const first = document.getElementById('name')?.value?.trim();
    const email = document.getElementById('email')?.value?.trim();

    // If no chooser buttons exist (Shopify gate v2), treat submit button's data-target as selected.
    if(!selectedTarget){
      const btnDefaultTarget = btnSubmit?.getAttribute('data-target');
      if(btnDefaultTarget) selectedTarget = btnDefaultTarget;
    }

    const ok = !!first && !!email && !!selectedTarget;
    btnSubmit.disabled = !ok;
  }

  // Handle assessment choice (if present)
  const choiceButtons = Array.from(document.querySelectorAll('button[data-target]')).filter(b => b.id !== 'btnSubmit');
  choiceButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      selectedTarget = btn.getAttribute('data-target');

      // UI state
      choiceButtons.forEach(b => b.classList.remove('secondary'));
      btn.classList.add('secondary');

      // Update customer note
      selectedInput.value = `Fortify Freemium: ${selectedTarget}`;
      status.textContent = `Selected: ${selectedTarget.replace('-', ' ')}`;
      validate();
    });
  });

  // Input listeners
  ['name','lastName','email','phone'].forEach(id => {
    document.getElementById(id)?.addEventListener('input', validate);
  });

  form.addEventListener('submit', (e) => {
    // Save data BEFORE submit
    const first = document.getElementById('name')?.value?.trim() || '';
    const last = document.getElementById('lastName')?.value?.trim() || '';
    const email = document.getElementById('email')?.value?.trim() || '';
    const phone = document.getElementById('phone')?.value?.trim() || '';

    if(!selectedTarget){
      // No selector present? Try submit button target.
      const btnDefaultTarget = btnSubmit?.getAttribute('data-target');
      if(btnDefaultTarget) selectedTarget = btnDefaultTarget;
    }

    if(!selectedTarget){
      e.preventDefault();
      status.textContent = 'Choose an assessment first.';
      return;
    }

    // Save to sessionStorage for hard gate + prefill
    const data = {
      name: normalizeName(first, last),
      firstName: first,
      lastName: last,
      email,
      phone,
      target: selectedTarget,
      ts: Date.now()
    };
    saveGateData(data);

    // We cannot guarantee Shopify will allow immediate redirect after POST in all themes.
    // If your theme supports return_to, add it here:
    // <input type="hidden" name="return_to" value="/pages/coherence" />

    status.textContent = 'Creating access…';
  });

  // If gate data already exists, offer quick continue
  const existing = getGateData();
  if(existing?.email && existing?.name){
    // On Shopify, we want the user to proceed directly to the tools (not re-submit).
    status.textContent = 'Access already unlocked on this device. Choose any tool below.';
    btnSubmit.disabled = false;
    btnSubmit.textContent = 'Continue to Tools';
    btnSubmit.addEventListener('click', (ev) => {
      ev.preventDefault();
      // Default continue destination
      const fallback = '/pages/coherence';
      const url = targetUrl(existing.target) || fallback;
      window.location.href = url;
    }, { once:true });
  }
});

// Expose for other pages
window.FORTIFY_GATE = { key: GATE_KEY, getGateData };